
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Acfourfivebharat() {



    const cardData =
    {
        keyword: 'Ac 45 Seater Bharat Benz Bus Hire Shirdi',
        heading: 'Amruta Travels: Ac 45 Seater Bharat Benz Bus Hire Shirdi',
        headingDescription: 'Amruta Travels offers AC 45 Seater BharatBenz Bus Hire in Shirdi, providing a luxurious and comfortable transportation solution for your group travel needs. Whether you are planning a pilgrimage, corporate event, wedding, or family trip, our well-maintained BharatBenz buses ensure a smooth and enjoyable journey. Equipped with air-conditioned interiors, plush seating, and ample luggage space, our 45-seater buses are designed for maximum comfort and reliability. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Shirdi simple and stress-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

   "services": [
    {
      "name": "Pune to Shirdi 45 Seater AC Bharat Benz Bus",
      "description": "Travel comfortably from Pune to Shirdi with our 45-seater AC Bharat Benz buses. Designed for long-distance pilgrimages, these buses offer pushback seats, air-conditioning, and ample legroom, making your spiritual journey smooth and relaxing."
    },
    {
      "name": "Shirdi Tour Bus Rental 45 Seater",
      "description": "Book our 45-seater buses for your Shirdi tour group. Ideal for religious yatras, family trips, or corporate pilgrimages, these spacious buses provide a safe and convenient mode of travel with experienced drivers and modern amenities."
    },
    {
      "name": "Bharat Benz Luxury Bus for Shirdi Darshan",
      "description": "Experience luxury and comfort on your Shirdi Darshan with Bharat Benz buses. Our premium buses are perfect for group tours and pilgrimage travel, equipped with AC, reclining seats, and entertainment systems for a relaxed ride."
    },
    {
      "name": "Group Travel Bus to Shirdi",
      "description": "Planning a group tour to Shirdi? Amruta Travels offers reliable group bus rentals with options for 25 to 50 seaters, ensuring a seamless and comfortable travel experience for spiritual getaways or religious tours."
    },
    {
      "name": "AC Coach Booking Shirdi Yatra",
      "description": "Book an AC coach for your next Shirdi Yatra from Pune. We provide well-maintained buses with air-conditioning, pushback seats, and a courteous driver, ideal for pilgrimage groups, senior citizens, or spiritual seekers."
    },
    {
      "name": "Corporate Pilgrimage Bus Pune",
      "description": "Amruta Travels offers dedicated pilgrimage bus services for corporates organizing employee religious trips. Our corporate Shirdi tour buses ensure a smooth, organized, and comfortable group experience from Pune."
    },
    {
      "name": "Family Tour Bus to Shirdi",
      "description": "Take your family on a peaceful journey to Shirdi in our safe and comfortable buses. Our family-oriented bus services offer clean interiors, courteous staff, and door-to-door pickup options from Pune."
    },
    {
      "name": "Wedding Trip Bus Shirdi",
      "description": "Organizing a wedding-related religious visit to Shirdi? Hire our luxury buses to ensure your guests travel in comfort and style. Ideal for family wedding groups, with flexible schedules and onboard facilities."
    },
    {
      "name": "Pune Religious Bus to Shirdi",
      "description": "Join the spiritual journey from Pune to Shirdi with Amruta Travels' religious bus service. Suitable for all types of darshan tours, we offer AC buses for individual groups, societies, or spiritual organizations."
    },
    {
      "name": "Volvo 45 Seater Shirdi Tour",
      "description": "Hire a 45-seater Volvo bus from Pune to Shirdi for your group. Our luxury Volvo coaches ensure a premium travel experience, featuring high-comfort interiors, AC, and onboard entertainment for long-distance travel."
    },
    {
      "name": "Pune to Sai Baba Temple Bus Hire",
      "description": "Travel from Pune to the Sai Baba Temple in Shirdi with our convenient bus hire service. Ideal for devotees, religious groups, and senior citizens, our buses ensure safety, punctuality, and comfort throughout the journey."
    },
    {
      "name": "Shirdi Group Package Bus",
      "description": "Looking for group tour packages to Shirdi? Amruta Travels offers affordable bus packages including transportation, seating arrangements, and travel coordination for your entire group’s pilgrimage."
    },
    {
      "name": "Sleeper Coach to Shirdi",
      "description": "For overnight trips to Shirdi from Pune, book our sleeper coach buses. Equipped with sleeping berths, AC, and safe interiors, these buses are perfect for long-distance religious tours with family or friends."
    },
    {
      "name": "Bharat Benz Yatra Bus Pune",
      "description": "Book a Bharat Benz bus for your Shirdi yatra from Pune. Our buses offer spacious interiors, excellent road performance, and AC features for a peaceful and memorable pilgrimage experience."
    },
    {
      "name": "Long Distance Shirdi Bus",
      "description": "Plan your long-distance religious travel to Shirdi with Amruta Travels. Our buses are specially designed for lengthy journeys, offering a smooth ride, onboard convenience, and hassle-free group travel."
    }
  ],
  "tableData": [
    ["Pune to Shirdi 45 Seater AC Bharat Benz Bus", "Shirdi Tour Bus Rental 45 Seater"],
    ["Bharat Benz Luxury Bus for Shirdi Darshan", "Group Travel Bus to Shirdi"],
    ["AC Coach Booking Shirdi Yatra", "Corporate Pilgrimage Bus Pune"],
    ["Family Tour Bus to Shirdi", "Wedding Trip Bus Shirdi"],
    ["Pune Religious Bus to Shirdi", "Volvo 45 Seater Shirdi Tour"],
    ["Pune to Sai Baba Temple Bus Hire", "Shirdi Group Package Bus"],
    ["Sleeper Coach to Shirdi", "Bharat Benz Yatra Bus Pune"],
    ["Long Distance Shirdi Bus"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "AC 45 Seater Bharat Benz Bus Hire in Shirdi",
    "WhyChoosedescription": "Amruta Travels offers the reliable and luxurious 45 Seater Bharat Benz buses for hire to Shirdi. Perfect for large groups, our buses provide a comfortable and convenient way to travel to this spiritual destination. Whether you're going for a religious trip, a family outing, or a corporate excursion, we ensure a smooth and safe journey."
  },
  {
    "WhyChooseheading": "Comfortable, Air-Conditioned Travel for Large Groups",
    "WhyChoosedescription": "Our AC 45 Seater Bharat Benz buses are designed with comfort in mind. Equipped with efficient air-conditioning, spacious seats, and ample legroom, your group will travel comfortably during the journey to Shirdi, ensuring a pleasant and restful experience throughout."
  },
  {
    "WhyChooseheading": "Ideal for Religious Pilgrimages, Family, and Corporate Trips",
    "WhyChoosedescription": "Whether it’s a religious pilgrimage to Shirdi, a family outing, or a corporate group trip, our 45 Seater Bharat Benz buses are perfect for large groups. We ensure that your group stays together and enjoys a hassle-free travel experience to one of India’s most visited spiritual destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Our drivers are experienced, licensed, and well-versed with the routes to Shirdi. They prioritize your safety and comfort, ensuring a smooth and timely journey while maintaining a courteous and professional attitude throughout your trip."
  },
  {
    "WhyChooseheading": "Well-Maintained Buses for a Smooth and Safe Journey",
    "WhyChoosedescription": "The 45 Seater Bharat Benz buses in our fleet are regularly maintained and serviced to ensure they are road-ready and safe for long journeys. We focus on providing a smooth and worry-free experience, allowing you to relax and focus on your trip to Shirdi."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Group Travel",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for your 45 Seater Bharat Benz bus rental. Our rates include fuel, tolls, driver allowances, and taxes—no hidden fees or surprises. You can easily budget for your group trip to Shirdi with our all-inclusive pricing."
  },
  {
    "WhyChooseheading": "Customized Solutions to Meet Your Group’s Needs",
    "WhyChoosedescription": "We understand that every group’s needs are different. Whether you require specific pick-up and drop-off points, or have special requests, Amruta Travels offers customized bus hire solutions for your Shirdi trip. We work with you to ensure that every detail of your travel is planned according to your preferences."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 45 Seater Bharat Benz bus with Amruta Travels is simple. You can reserve your bus online, over the phone, or visit our office. Our customer support team is available 24/7 to assist you with bookings, itinerary changes, and any other travel-related needs."
  }
]
























    }

const faqData = [
  {
    question: 'Can I hire an AC 45-seater Bharat Benz bus for a trip to Shirdi with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers AC 45-seater Bharat Benz buses for hire for trips to Shirdi. Our buses are ideal for group travel, ensuring comfort, luxury, and safety for your journey to the sacred town of Shirdi.',
  },
  {
    question: 'What amenities are available in the AC 45-seater Bharat Benz bus?',
    answer: 'The AC 45-seater Bharat Benz buses are equipped with comfortable reclining seats, air conditioning, ample legroom, USB charging ports, clean and sanitized interiors, and overhead storage. The bus is designed for long journeys, ensuring a pleasant travel experience.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus suitable for both local and outstation travel?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is perfect for both local travel within Pune and outstation trips, including Shirdi. The bus is well-equipped to handle long-distance travel with ease and comfort.',
  },
  {
    question: 'Is a driver included in the bus rental for the Shirdi trip?',
    answer: 'Yes, all our bus rentals, including the AC 45-seater Bharat Benz bus, come with an experienced and professional driver. The driver ensures a safe and timely journey to Shirdi, following all necessary routes and guidelines.',
  },
  {
    question: 'How much does it cost to hire an AC 45-seater Bharat Benz bus for a trip to Shirdi?',
    answer: 'The cost of hiring an AC 45-seater Bharat Benz bus for a trip to Shirdi depends on the distance, duration of the trip, and specific requirements. Rates typically start from ₹30–₹40 per km. For an accurate and customized quote, please contact us with your itinerary.',
  },
  {
    question: 'Is the AC 45-seater Bharat Benz bus comfortable for long journeys to Shirdi?',
    answer: 'Yes, the AC 45-seater Bharat Benz bus is designed for long journeys, offering top-tier comfort, air conditioning, and spacious seating. It’s perfect for a smooth and relaxed ride to Shirdi, ensuring your comfort throughout the trip.',
  },
  {
    question: 'Are the buses regularly maintained and sanitized?',
    answer: 'Yes, we prioritize hygiene and safety. All our buses, including the AC 45-seater Bharat Benz, are thoroughly inspected, maintained, and sanitized before every trip to ensure a clean and safe environment for all passengers.',
  },
  {
    question: 'How do I book an AC 45-seater Bharat Benz bus for a trip to Shirdi?',
    answer: 'Booking an AC 45-seater Bharat Benz bus for your Shirdi trip is easy. You can book online through our website or contact our customer support team. We offer quick booking assistance and transparent pricing to make your travel experience hassle-free.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Raghavendra Joshi',
    role: 'Business Owner, Pune',
    text: 'We hired an AC 45-seater Bharat Benz bus for a trip to Shirdi. The bus was luxurious, clean, and comfortable. The driver was professional, and the journey was smooth and enjoyable. I highly recommend Amruta Travels for any group travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sunita Deshmukh',
    role: 'Pilgrimage Tour Organizer, Pune',
    text: 'I booked the AC 45-seater Bharat Benz bus for a group of pilgrims heading to Shirdi. The bus was well-maintained, and the journey was extremely comfortable. Amruta Travels provided excellent service, and we will definitely book with them again.',
    rating: 5,
  },
];
































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC 45 Seater Bharat Benz Bus Hire Shirdi",
  "image": "https://bushireinpune.com/assets/images/45-seater-bharat-benz-shirdi.jpg",
  "description": "Amruta Travels offers AC 45 Seater Bharat Benz Bus Hire for your Shirdi trip. Travel comfortably with our luxury buses for group tours, religious pilgrimages, family trips, and corporate events to Sai Baba Temple. Book your Shirdi Yatra bus now for a smooth and safe journey from Pune to Shirdi and experience hassle-free travel in a premium Bharat Benz bus.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "16000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-45-seater-bharat-benz-bus-hire-shirdi"
  }
};




    return (
        <div>
            
<Helmet>
  <title>Call: +91 7353109555 | AC 45 Seater Bharat Benz Bus Hire Shirdi | Pune to Shirdi Yatra & Religious Tour</title>
  <meta 
    name="description" 
    content="Hire an AC 45 Seater Bharat Benz bus for your Shirdi trip. Comfortable and luxury bus rental for group travel, religious yatra, corporate pilgrimage, and family trips from Pune to Sai Baba Temple in Shirdi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/92.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Acfourfivebharat;